module.exports = __webpack_public_path__ + "img/kccx.0f9d620f.png";